<template>
  <div class="whiteBG">
    <div class="w1200">
      <a-breadcrumb>
        <a-breadcrumb-item><router-link to="/index">首页</router-link></a-breadcrumb-item>
        <a-breadcrumb-item><router-link to="/offLineList">线下活动</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>{{ OfflineData.title }}</a-breadcrumb-item>
      </a-breadcrumb>

      <div class="live_cover">
        <div class="cover_box">
          <img :src="OfflineData.thumb" alt="" />
        </div>
        <div class="intro_box">
          <div class="intro_title">
            <div class="course_title">
              <a-tag class="newTag" v-if="OfflineData.is_new == 1">新客专享</a-tag>
              <a-tag class="vipTag" v-if="OfflineData.is_member == 1">会员专享</a-tag>
              {{ OfflineData.title }}
            </div>
            <div class="courser_view">
              <div class="left">
                <span>
                  <i class="iconfont icon-zwliulanliang"></i>
                  {{ OfflineData.browse_num }}
                </span>
                <span>
                  <i class="iconfont icon-zwbaomingrenshu"></i>
                  {{ OfflineData.applicant_num }}
                </span>
              </div>
              <a-tooltip>
                <template #title>
                  <img :src="OfflineData.xcx_img" alt="" />
                  <a-button type="primary" @click="copyUrl(OfflineData.offline_url, OfflineData.id)">复制链接</a-button>
                </template>
                <i class="iconfont icon-zwfenxiang1"></i>
              </a-tooltip>
            </div>
          </div>
          <div class="intro_details">
            <a-form ref="ticketFormRef" :model="ticketForm" :rules="ticketFormRules">
              <a-form-item class="site-form-item">
                <span class="label"><i class="iconfont icon-zwdidian1"></i>地点：</span>
                <span class="site" v-if="OfflineData.site != ''" :title="OfflineData.site">{{ OfflineData.site }}</span>
                <div class="site" v-else>各个地区的活动地点由管理员通知</div>
              </a-form-item>
              <a-form-item>
                <span class="label"><i class="iconfont icon-zwzhiboshijian"></i>时间：</span>
                <span class="time">{{ OfflineData.begin_date }}</span>
              </a-form-item>
              <a-form-item>
                <span class="label"><i class="iconfont icon-zwkechengjiage"></i>价格：</span>
                <span class="price">￥{{ ticketPrice }}</span>
              </a-form-item>
              <a-form-item name="ticketValue">
                <span class="label"><i class="iconfont icon-zwpiaozhong1"></i>票种：</span>
                <div class="selectBox">
                  <a-select v-model:value="ticketForm.ticketValue" placeholder="Automatic tokenization" size="large"
                    style="width: 200px" @select="ticketSelect(OfflineData.ticket, ticketForm.ticketValue)">
                    <a-select-option :value="item.id" v-for="item in OfflineData.ticket" :key="item.id"
                      :disabled="item.limit_type == 0"><i class="ticketPrice">￥{{ item.price }}</i> {{ item.title }}
                      <i v-if="item.limit_type == 0">(已售罄)</i></a-select-option>
                  </a-select>
                  <img src="@/assets/images/select_icon.png" class="select_icon" v-if="ticketForm.ticketValue != ''" />
                </div>
                <div class="remark" v-if="this.review_type == 1">需后台审核</div>
              </a-form-item>
            </a-form>
          </div>
          <div class="operate_box">
            <div class="operate_btn">
              <a-button type="primary" size="large" block v-if="OfflineData.type == 0 && userInfo == null"
                @click="applyLoginBtn">前往报名</a-button>

              <a-button type="primary" size="large" block v-if="OfflineData.type == 0 && userInfo != null"
                @click="applyBtn">前往报名</a-button>
              <a-button type="primary" size="large" block :href="OfflineData.offline_url" target="_blank"
                v-else-if="OfflineData.type == 1">查看回顾</a-button>
              <a-button type="primary" size="large" block disabled v-else-if="OfflineData.type == 2">暂无回顾</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w1200">
    <div class="list_content">
      <div class="dlist_left">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="活动概述">
            <div class="content" v-html="OfflineData.content"></div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="list_right">
        <!-- 联系我们 -->
        <ContactYL />
        <!-- DTC独立站 -->
        <a class="DtcBanner" href="https://dwz.cn/liUeWWoA" target="_blank">
          <img src="@/assets/images/hotDtcBanner.jpeg" alt="" />
        </a>
        <!-- 热门直播 -->
        <HotLive />
        <!-- 推荐课程 -->
        <HotCourse />
      </div>
    </div>
  </div>

  <!-- 评价弹框 -->
  <RateDialog />
</template>

<script>
import '@/assets/css/list.less'
import '@/assets/css/details.less'
import RateDialog from '@/components/details/RateDialog.vue'
import ContactYL from '@/components/hot/ContactYL.vue'
import HotLive from '@/components/hot/HotLive.vue'
import HotCourse from '@/components/hot/HotCourse.vue'
export default {
  name: 'OffLineDetails',
  components: { RateDialog, ContactYL, HotLive, HotCourse },
  props: ['offlineId'],
  data() {
    return {
      tdk: '',
      userInfo: null,
      liveState: 0,
      activeKey: '1',
      ticketForm: {
        ticketValue: '',
      },
      ticketFormRules: {
        ticketValue: [{ required: true, message: '请选择票种', trigger: 'change' }],
      },
      OfflineData: {},
      // 票种是否需要审核
      ticketPrice: 0,
      review_type: 0,
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.getOfflineData()
    let goUrl = this.isMobile()
    if (goUrl === 1) {
      //移动端地址
      location = `https://acadmin.yinolink.com/oview/${this.offlineId}`
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      if (navigator.userAgent.match(/pad/i)) {
        flag = false
      }
      localStorage.setItem('isMobile', flag ? 1 : 0)
      let goUrl = flag ? 1 : 0
      return goUrl
    },
    async getOfflineData() {
      if (this.offlineId == undefined) {
        this.$router.push('/offlineList')
      }
      const { data: res } = await this.$http.post('/offline/view', { id: this.offlineId })
      this.OfflineData = res.data
      this.ticketPrice = this.OfflineData.ticket[0].price
      this.ticketForm.ticketValue = this.OfflineData.ticket[0].id
      this.review_type = this.OfflineData.ticket[0].review_type

      this.tdk = res.tdk
      this.$nextTick(() => {
        document.title = `${this.tdk.title}`
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.tdk.keyword)
        document.querySelector('meta[name="description"]').setAttribute('content', this.tdk.description)
      })
    },
    ticketSelect(option, value) {
      option.forEach((item) => {
        if (item.id == value) {
          this.ticketPrice = item.price
          return (this.review_type = item.review_type)
        }
      })
    },
    applyLoginBtn() {
      this.$bus.emit('openLogin')
    },
    async applyBtn() {
      try {
        if (this.OfflineData.is_member == 1 && this.userInfo.crm_id == 0) {
          this.$message.warning('该活动为会员专享活动')
          return
        }
        const values = await this.$refs.ticketFormRef.validateFields()
        // console.log('Success:', values.ticketValue)
        this.$router.push({
          name: 'OffLineApply',
          query: {
            id: values.ticketValue,
          },
        })
      } catch (errorInfo) {
        // console.log('Failed:', errorInfo.outOfDate)
      }
    },
    copyUrl(url, id) {
      this.$copyText(`https://academy.yinolink.com/offLineDetails?id=${id}`).then(
        (e) => {
          this.$message.success('复制成功！')
        },
        (e) => {
          this.$message.error('暂无链接！')
        }
      )
    },
    RateBtn() {
      this.$bus.emit('rateDialog')
    },
  },
}
</script>

<style lang="less" scoped>
.live_cover {
  .intro_box {
    width: 387px;
    height: 488px;

    .intro_title {
      width: 100%;
      height: 120px;
      padding: 20px;

      .course_title {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        min-height: 56px;
        line-height: 28px;
      }

      .courser_view {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);

        .left {
          display: flex;
          align-items: center;

          span {
            display: flex;
            align-items: center;

            i {
              margin-right: 4px;
            }

            &:first-child {
              margin-right: 32px;
            }
          }
        }

        .icon-zwfenxiang1 {
          font-size: 20px;
          color: #3A84FF;
          cursor: pointer;
        }
      }
    }

    .intro_details {
      width: 100%;
      height: 295px;
      background-color: #f9f9f9;
      padding: 20px;

      .ant-form {
        .site-form-item {
          :deep(.ant-form-item-control-input-content) {
            display: flex;
            align-items: center;
          }

          .site {
            width: 75%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
          }
        }

        .label {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          margin-right: 8px;

          i {
            font-size: 20px;
            color: rgba(0, 0, 0, 0.65);
            margin-right: 4px;
            vertical-align: middle;
          }
        }

        .site {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
        }

        .time {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
        }

        .price {
          color: #ff4d4f;
        }

        .selectBox {
          position: relative;
          display: inline-block;
        }

        .ticketPrice {
          color: #3A84FF;
        }

        .select_icon {
          position: absolute;
          bottom: 0;
          right: 0px;
          width: 15px;
          height: 15px;
        }

        :deep(.ant-select-selector) {
          border-color: #3A84FF;
        }

        .remark {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.45);
          text-align: center;
          margin-top: 8px;

          i {
            font-size: 14px;
            margin-right: 4px;
          }
        }
      }
    }

    .operate_btn {
      .ant-btn-primary {
        width: 100%;
      }
    }
  }
}
</style>
